import { InputHTMLAttributes, forwardRef } from "react";

import { inputStyle } from "./Input.css";

export interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  type?:
    | "text"
    | "password"
    | "email"
    | "number"
    | "tel"
    | "url"
    | "search"
    | "date"
    | "time"
    | "datetime-local"
    | "month"
    | "week";
  isDisabled?: boolean;
  isInvalid?: boolean;
  isReadOnly?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type = "text",
      isDisabled = false,
      isInvalid = false,
      isReadOnly = false,
      className,
      ...rest
    },
    ref
  ) => {
    const combinedClassName = `${inputStyle} ${className || ""}`.trim();

    return (
      <input
        ref={ref}
        type={type}
        className={combinedClassName}
        disabled={isDisabled}
        readOnly={isReadOnly}
        aria-invalid={isInvalid ? true : undefined}
        {...rest}
      />
    );
  }
);
